export default {
  most_popular: '#{{rank}} Beliebtesten',
};
